import { useNavigate } from "react-router-dom";
import { KeyDrivePrimaryButton } from "../../../../../components/KeydriveComponents/Buttons/KeyDrivePrimaryButton";
import { Grid } from "@mui/material";
import { KeyDriveBodyMin } from "../../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { HowToRegSharp } from "@mui/icons-material";


interface IEditFolderPrivilegeHandler {
    nameOrg: string;
    idWorkspace: string;
    idFolder: string;
}

function EditFolderPrivilegeHandler({
    idFolder,
    idWorkspace,
    nameOrg
}: IEditFolderPrivilegeHandler) {

    const navigate = useNavigate();

    return (
        <Grid item xs={12} mt="20px">
            <KeyDrivePrimaryButton 
                onClick={() => { navigate(`/${nameOrg}/wsallowed/${idWorkspace}/${idFolder}/PermissionUser`) }}
                TextComponent={KeyDriveBodyMin}
                TextComponentProps={{
                    color: "",
                    needBold: false,
                    needEllipses: false,
                    text: "Gerenciar permissões"
                }}
                disabled={false}
                startIcon={<HowToRegSharp />}
                height="36px"
                needFullWidth
            />
        </Grid>
    )
}

export default EditFolderPrivilegeHandler;